// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import "trix"
import "@rails/actiontext"

import ahoy from "ahoy.js"

const ahoySkip = () => !!document.querySelector('meta[name="ahoy-skip"]')

if (ahoySkip()) ahoy.configure({ trackVisits: false })
ahoy.configure({ visitDuration: 240 })
document.addEventListener("turbo:load", () => { if (!ahoySkip()) ahoy.trackView() })

// Let the server render times in the viewer's local time zone (see Admin::BaseController#use_browser_time_zone)
try {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  if (tz) document.cookie = `browser_time_zone=${encodeURIComponent(tz)}; path=/; max-age=31536000; SameSite=Lax`
} catch (e) {}
